import React from "react";

export default function Check(props: any) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
      <path d="M14.226 5.23875C14.5419 4.92986 14.5476 4.42336 14.2387 4.10745C13.9298 3.79154 13.4233 3.78585 13.1074 4.09474L14.226 5.23875ZM6.16668 12.0001L5.6137 12.5782L6.17279 13.113L6.72597 12.5721L6.16668 12.0001ZM2.88632 7.7553C2.56704 7.4499 2.06063 7.46115 1.75523 7.78044C1.44983 8.09972 1.46108 8.60613 1.78037 8.91153L2.88632 7.7553ZM13.1074 4.09474L5.60738 11.4281L6.72597 12.5721L14.226 5.23875L13.1074 4.09474ZM6.71966 11.422L2.88632 7.7553L1.78037 8.91153L5.6137 12.5782L6.71966 11.422Z" fill="currentColor" />
    </svg>
  )
}